import { getUserId } from 'data/storage';
import { Room } from 'type/room';
import dayjs from 'dayjs';
import { formatEndTime } from 'util/format';
import { getAdressBoookConfig } from 'api/contact';
import { AdressBoookConfig } from 'type/http';

export enum ApprovalRight {
  /** 正常权限 */
  approval = 'approval',
  /** 需审批 */
  needApproval = 'needApproval',
  /** 无权限 */
  noRight = 'noRight'
}

/**
 * 获取审批权限
 */
export function getApprovalRight(roomAuditConfigDetailView: Room['roomAuditConfigDetailView']) {
  if (!roomAuditConfigDetailView) return ApprovalRight.approval;
  const { auditorStaffList, bookingStaffList } = roomAuditConfigDetailView;
  const userId = getUserId();
  if (auditorStaffList.some((val: any) => val.userId === userId)) return ApprovalRight.approval;
  if (bookingStaffList.some((val: any) => val.userId === userId)) return ApprovalRight.needApproval;
  return ApprovalRight.noRight;
}

const WEEK_LIST = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

/**
 * 格式化时间 2022年10月15日（周六） 20:15 - 20:30
 */
export function parseTime(start: number, end: number, format = 'YYYY年MM月DD日') {
  const startDayjs = dayjs(start);
  const week = WEEK_LIST[startDayjs.day()];
  return `${startDayjs.format(format)}（${week}） ${startDayjs.format('HH:mm')} ~ ${formatEndTime(dayjs(end).format('HH:mm'))}`;
}

export async function getAdressConfig(companyId: string | any) {
  const ADDRESS = 'com.maxhub.meetingclient';
  try {
    const res = (await getAdressBoookConfig(companyId, ADDRESS)) as AdressBoookConfig;
    const { modules } = JSON.parse(res.configuration);
    const organizationConfig = (modules.find((item: any) => item.key === 'organization') || {}).configs || {};
    return organizationConfig.enabled;
  } catch (error) {
    // 匹配 领效星云（通讯录预约默认打开的产品逻辑），如果请求失败或者获取失败，那么默认打开通讯录预约，也就是展示组织架构
    console.log('error-getAdressConfig:', error);
    return true;
  }
}
